import { useMemo, useRef } from 'react';
import type { AppSelectRegistryCtx } from '@/components/shared/AppSelect/types';

/** Internal label-registry for AppSelect — maps option values to their display labels */
export function useRegistry(): AppSelectRegistryCtx {
  const registryRef = useRef<Map<string, string>>(new Map());
  return useMemo<AppSelectRegistryCtx>(
    () => ({
      register: (v, label) => registryRef.current.set(v, label),
      getLabel: v => registryRef.current.get(v),
      getAll: () => registryRef.current,
    }),
    [],
  );
}
